import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/ResetPasswordForm/resetPasswordForm.container"
    ).then((module) => ({
        default: module.ResetPasswordFormContainer
    }))
);
